module.exports = __webpack_public_path__ + "img/adorno-5.02c483ff.png";